import { AdobeEventRecord } from './AnalyticsDispatchers/AdobeAnalyticsDispatcher';

/** The set of events which our Adobe Launch implementation understands */
export enum TrackingEvent {
  APPOINTMENT_LIST = 'Appointment List',
  BOOKING_FORM_APPOINTMENT_TYPES_SHOWN = 'Booking Form Appointment Types Shown',
  BOOKING_FORM_START = 'Booking Form Start',
  BOOKING_FORM_ERROR = 'Booking Form Error',
  BOOKING_FORM_ROADBLOCK = 'Booking Form Roadblock',
  BOOKING_FORM_STEP_CHANGE = 'Booking Form Step Change',
  BROWSE_BY_LOCATION = 'Browsed by Location',
  BROWSED_BY_GENDER = 'Browsed by Gender',
  BROWSED_BY_STATE = 'Browsed by State',
  CHEM2U_CLICKED = 'Chemist2U interacted with',
  CHEM2U_RENDERED = 'Chemist2U button shown',
  CLICKED_LOAD_MORE = 'Clicked Load More Results Button',
  ERROR_PAGE_LOADED = 'Error Page Loaded',
  FLAGR_TRIGGERED = 'Flagr Triggered',
  FORM_COMPLETE = 'Form Complete',
  SERVER_ERROR = 'Server Error',
  FORM_FIELD_ERROR = 'Form Field Error',
  FORM_STEP_CHANGE = 'Form Step Change',
  FORM_TIME_OUT = 'Form Timeout',
  GENERIC_PAGE_LOAD = 'Generic Page Load',
  HAMBURGER_CLICKED = 'Hamburger Menu Button Clicked',
  INITIAL_PAGE_LOAD = 'Initial Page Load',
  LANDING_PAGE_LOADED = 'Landing Page Loaded',
  LANGUAGE_CHANGE = 'Language Change',
  LOGOUT_CLICKED = 'Logout Clicked',
  LOGGED_IN = 'Logged in',
  MEDIA_AD_DISPLAYED = 'Media Ad Displayed',
  MEMBER_OFFER_ACCOUNT_POPUP = 'member-offer-account-popup',
  NOT_ACCEPTING_EXISTING_PATIENTS_DISPLAYED = 'bf-notaccepted-displayed',
  NOT_ACCEPTING_NEW_PATIENTS_DISPLAYED = 'bf-notacceptingnewpatients',
  NOT_AVAILABLE_DISPLAYED = 'bf-notavailable-displayed',
  PAGE_CONTENT_LOADED = 'Page Content Loaded',
  PAGE_LOADED = 'Page Loaded',
  PERFORMANCE_REPORTED = 'Performance reported',
  PRIVACY_PREFERENCE_SECTION_CLICKED = 'Privacy Preference section interacted with',
  PRIVACY_PREFERENCE_SECTION_RENDERED = 'Privacy Preference section button shown',
  PROFILE_NEARBY_APPOINTMENTS_LOADED = 'Profile Page Nearby Appointments Loaded',
  PROFILE_STILL_LOOKING_LOADED = 'Profile Page Still Looking Loaded',
  PROFILE_PAGE_LOADED = 'Profile Page Loaded',
  PROFILE_PRACTICE_LINK_CLICKED = 'Profile Practice Link Clicked',
  PROFILE_PHONE_CLICKED = 'Profile Page Phone Number Clicked',
  PROFILE_SOCIAL_LINK_CLICKED = 'Profile Social Link Clicked',
  PROFILE_ENTER_BUSINESS_ID = 'Enter Profile Page with business_id',
  SEARCH_BAR_ENTER_PRESS = 'Search Bar Enter Press',
  SEARCH_BOX_CLICKED = 'Search Box Clicked',
  SEARCH_PERFORMED = 'Search Performed',
  TOO_LONG_DISPLAYED = 'bf-toolong-displayed',
  PREFERRED_PROVIDER_DIALOG_POPUP = 'preferred-provider-dialog-popup',
  BLACKLIST_DISPLAYED = 'bf-blmessage',
  RECAPTCHA_VERIFICATION_TRIGGERED = 'Recaptcha Verification Triggered',
  RECAPTCHA_CHALLENGE_FAILED = 'Recaptcha Challenge Failed',
  HEALTH_INTERESTS_SHOWN = 'Health Interests Shown',
  HEALTH_INTERESTS_INTERACTED = 'Health Interests Interacted',
  GOOGLE_ONE_TAP_LOGGEDIN = 'Google One Tap Logged in',
  GOOGLE_ONE_TAP_NOT_DISPLAYED = 'Google One Tap Not Displayed',
  GOOGLE_ONE_TAP_SKIPPED = 'Google One Tap Skipped',
  GOOGLE_ONE_TAP_DISPLAYED = 'Google One Tap Displayed',
  GOOGLE_ONE_TAP_DISMISSED = 'Google One Tap Dismissed',
}

export type TrackingEventRecordList = AdobeEventRecord[];
